"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const suggestion_status_1 = require("@Components/MatchComponents/v2/suggestion-status");
const react_1 = __importStar(require("react"));
require("./index.scss");
const matching_1 = require("@App/api/routes/rightsholder/matching");
const contexts_1 = require("@App/contexts");
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const DashboardNoDataInfo_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardNoDataInfo"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const LinkedStatusComponent_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardMatchHistoryCard/LinkedStatusComponent"));
const isMatchSummaryEmpty = (summary) => summary && (summary.submitted || summary.accepted || summary.rejected);
const DashboardMatchHistoryCard = () => {
    var _a, _b, _c;
    const { rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [matchSummary, setMatchSummary] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const currentRhId = rightsholderStore.currentRightsholderId;
    (0, react_1.useEffect)(() => {
        (0, matching_1.getMatchSummary)(rightsholderStore.currentRightsholderId).then((result) => {
            setMatchSummary(result.data);
            setIsLoading(false);
        });
    }, []);
    return (react_1.default.createElement("div", { className: 'dashboard-content-card match-history' },
        react_1.default.createElement("div", { className: 'match-history-title' },
            "Your Match History",
            react_1.default.createElement(CustomToolTip_1.default, { info: "Match History is a record of recent match suggestions that you've made for unmatched recording groups.", type: '?', inverse: true })),
        react_1.default.createElement("div", { className: 'match-history-indicators' }, isLoading ? (react_1.default.createElement(PointPreloader_1.default, null)) : isMatchSummaryEmpty(matchSummary) ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(LinkedStatusComponent_1.default, { status: suggestion_status_1.SUGGESTION_STATUS.SUBMITTED, count: (_a = matchSummary === null || matchSummary === void 0 ? void 0 : matchSummary.submitted) !== null && _a !== void 0 ? _a : 0, rhId: currentRhId }),
            react_1.default.createElement(LinkedStatusComponent_1.default, { status: suggestion_status_1.SUGGESTION_STATUS.ACCEPTED, count: (_b = matchSummary === null || matchSummary === void 0 ? void 0 : matchSummary.accepted) !== null && _b !== void 0 ? _b : 0, rhId: currentRhId }),
            react_1.default.createElement(LinkedStatusComponent_1.default, { status: suggestion_status_1.SUGGESTION_STATUS.REJECTED, count: (_c = matchSummary === null || matchSummary === void 0 ? void 0 : matchSummary.rejected) !== null && _c !== void 0 ? _c : 0, rhId: currentRhId }),
            react_1.default.createElement("div", { className: 'link-container' },
                react_1.default.createElement(react_router_dom_1.Link, { to: navigation_1.default.rightholder.matchClaim.matchHistory(currentRhId) }, "View More")))) : (react_1.default.createElement(DashboardNoDataInfo_1.default, { type: 'Match History' })))));
};
exports.default = DashboardMatchHistoryCard;
